import { z } from 'zod';
import _isEmpty from 'lodash/isEmpty';

export const FORM_SCHEMA = z.object({
  slas: z.record(z.boolean()).refine(slas => !_isEmpty(slas), {
    message: 'At least one service must be selected.'
  })
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  slas: {}
};
